import { render } from "./addtoCal.vue?vue&type=template&id=5dc772e8&scoped=true"
import script from "./addtoCal.vue?vue&type=script&lang=js"
export * from "./addtoCal.vue?vue&type=script&lang=js"

import "./addtoCal.vue?vue&type=style&index=0&id=5dc772e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc772e8"]])

export default __exports__